import { Money } from "@saas/shared/utils/formatter/money/money";

import { PromoLabelEnum } from "../../@enum/store/promo-rule-type/promo-rule-type.enum";
import { StorePromoRewardInterface } from "../../@interface/store/store-promo-reward/store-promo-reward.interface";

export type GetPromoRewardLabelInput = {
  label: PromoLabelEnum;
  minimumQuantity?: number;
  nominal?: Money;
  maximum?: Money;
  reward: StorePromoRewardInterface;
};

export type GetPromoRewardLabelOutput = string;

export const getPromoRewardLabel = ({
  label,
  minimumQuantity,
  nominal,
  maximum,
  reward,
}: GetPromoRewardLabelInput): GetPromoRewardLabelOutput => {
  const percentage = reward.percentage;
  const quantity = reward.quantity;
  const itemName = reward.item?.name;

  if (label === PromoLabelEnum.SHIPPING_DISCOUNT && nominal)
    return `Potongan ${nominal.currencyValue}`;

  if (label === PromoLabelEnum.PRODUCT_BUY_N_GET_M) {
    return `Buy N Get ${quantity}, Min. Pembelian: ${minimumQuantity} barang`;
  }

  if (itemName && label === PromoLabelEnum.PRODUCT_BUNDLING) {
    return `FREE Bundling (Gratis Produk): "${itemName}"`;
  }

  if (nominal) {
    return `Diskon: ${nominal.currencyValue}`;
  }

  if (percentage && maximum && label !== PromoLabelEnum.PRODUCT_DISCOUNT) {
    return `Diskon: ${percentage}%, Maks: ${maximum.currencyValue}`;
  }

  if (percentage) {
    return `Diskon: ${percentage}%`;
  }

  return "";
};

export default getPromoRewardLabel;
